import { map, isEmpty } from 'lodash';

import * as templateOps from '../../api/AnnotationTemplates/annotation-template-operations';
import * as videoOps from '../../api/Videos/video-operations';

const generateVideoPDF = (video, elementVideo) => {
  const trackVideo = videoOps.getTrack(video);
  const pdfLines = [];
  let templateIndex = 0;
  let controlPointsIndex = 0;
  let pdf = `Video ${videoOps.getName(video)}\n\n`;
  if (elementVideo === 'Video') {
    pdf += `Type: ${videoOps.getType(video)}\n`;
    pdf += `Url: ${videoOps.getURL(video)}\n`;
    pdf += `Coordinates data type: ${videoOps.getCoordinatesDataType(video)}\n`;
    pdf += 'Annotations templates:\n';
    map(videoOps.getAnnotationTemplates(video), element => {
      templateIndex += 1;
      pdf += `template ${templateIndex}: ${templateOps.getName(element)}\n`;
    });
    pdf += `Time GPS recording: ${videoOps.getTimeGPS(video)}\n`;
    pdf += `latlng0: ${videoOps.getLatLng0(video)}\n`;
    pdfLines.push(pdf);
    pdf = '';
  }
  if (!isEmpty(trackVideo)) {
    pdf += 'Track:\n\n';
    pdf += '\tcoordinates:\n\n';
    let countLines = 0;
    map(trackVideo.geometry.coordinates, element => {
      if (countLines === 40) {
        pdfLines.push(pdf);
        countLines = 0;
        pdf = '';
      }
      pdf += `[${element}]\n`;
      countLines += 1;
    });
    const controlPoints = videoOps.getControlPoints(video);

    pdf += '\ncontrol points:\n';
    map(controlPoints.features, (point, index) => {
      controlPointsIndex += 1;
      pdf += `control point ${controlPointsIndex}:\n`;
      pdf += '\t\tproperties:\n';
      pdf += `\t\tdistanceTravelled: ${point.properties.distanceTravelled}\n`;
      pdf += `\t\tisControlPoint: ${point.properties.isControlPoint}\n`;
      pdf += `\t\ttimeUS: ${point.properties.timeUS}\n`;
      pdf += '\tgeometry:\n';
      pdf += `\t\tcoordinates: ${point.geometry.coordinates}`;
      pdf += '\n';
      if (index % 2 === 0) {
        pdfLines.push(pdf);
        pdf = '';
      }
    });
  }
  return pdfLines;
};

export default generateVideoPDF;
